import { observer } from "mobx-react-lite";
import { useRef, useState } from "react";
import { cn } from "ui";

import { EditableGroupName } from "src/components/EditableWorkoutItemGroupName";
import { ExerciseDraftView } from "src/components/ExerciseDraftWorkoutItemView";
import { Stack } from "src/convenience/stack";
import {
  draftWorkoutItemStackContext,
  type DraftWorkoutItemViewProps,
} from "src/workouts/DraftWorkoutItemView.shared";
import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";
import { WorkoutItemWrapper } from "src/workouts/WorkoutItemWrapper";

import { useOnClickOutside } from "../hooks/useOnClickOutside";

export const DraftWorkoutItemView = observer(function DraftWorkoutItemView(
  props: DraftWorkoutItemViewProps,
) {
  const workoutEditStore = useWorkoutEditStore();

  const workoutItem = workoutEditStore.getWorkoutItemById(
    props.layout.workoutItemId,
  );
  const ref = useRef(null);
  const [stackContextValue] = useState(() => {
    return { stack: new Stack<string>() };
  });

  useOnClickOutside(ref, (event) => {
    if (
      event.target &&
      "classList" in event.target &&
      (event.target as HTMLElement).classList.contains("sheet-overlay")
    ) {
      return;
    }

    if (stackContextValue.stack.size > 0) {
      return;
    }

    workoutEditStore.removeItem(workoutItem.id);
  });

  let draftView;

  if (workoutItem.type === "NORMAL") {
    draftView = (
      <ExerciseDraftView
        workoutItemId={props.layout.workoutItemId}
        index={props.index}
      />
    );
  } else {
    draftView = (
      <EditableGroupName workoutItemId={props.layout.workoutItemId} isLoading />
    );
  }

  const isSuperset = workoutItem.parentId
    ? workoutEditStore.getIsWorkoutItemSuperset(workoutItem.parentId)
    : false;

  return (
    <draftWorkoutItemStackContext.Provider value={stackContextValue}>
      <WorkoutItemWrapper
        ref={ref}
        className={cn("flex flex-col p-2 gap-2", {
          "my-6": isSuperset,
        })}
      >
        {draftView}
      </WorkoutItemWrapper>
    </draftWorkoutItemStackContext.Provider>
  );
});
